
import React from 'react';
import { BriefcaseBusiness, TrendingUp, Users } from 'lucide-react';
import BusinessPricingHeader from './BusinessPricingHeader';
import BusinessPricingCard from './BusinessPricingCard';
import BusinessInfoBox from './BusinessInfoBox';

const BusinessPricingSection = () => {
  const pricingCards = [
    {
      title: "Führungskräfte Coaching",
      description: "Individuelle Begleitung für Führungspersönlichkeiten, die ihre emotionale Intelligenz stärken und authentischer führen möchten.",
      features: [
        "Persönliche 1:1 Coaching-Sessions",
        "Emotionale Intelligenz stärken",
        "Authentischer Führungsstil"
      ],
      icon: <BriefcaseBusiness className="h-6 w-6" />,
      priceInfo: {
        amount: "ab 200 € / Stunde",
        unit: "Stunde"
      },
      serviceType: "leadership"
    },
    {
      title: "Katalysator-Führung",
      description: "Entwickeln Sie einen Führungsstil, der als Katalysator für Mitarbeiterbindung, Innovation und nachhaltige Rentabilität wirkt.",
      features: [
        "Strategische Führungsentwicklung",
        "Mitarbeiterbindung steigern",
        "Nachhaltige Unternehmensentwicklung"
      ],
      icon: <TrendingUp className="h-6 w-6" />,
      priceInfo: {
        amount: "ab 250 € / Stunde",
        unit: "Stunde"
      },
      serviceType: "catalyst"
    },
    {
      title: "Team-Entwicklung",
      description: "Stärkung der Zusammenarbeit und Potenzialentfaltung in Teams.",
      features: [
        "Workshops und Teamtage",
        "Konfliktlösung und Kommunikation",
        "Gemeinsame Zielfindung"
      ],
      icon: <Users className="h-6 w-6" />,
      priceInfo: {
        amount: "ab 1.200 € / Tag",
        unit: "Tag"
      },
      serviceType: "team"
    }
  ];

  return (
    <section className="py-12 md:py-24 bg-gradient-to-b from-white to-joerg-50">
      <div className="container px-4 sm:px-6 md:px-8">
        <BusinessPricingHeader />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pricingCards.map((card, index) => (
            <BusinessPricingCard
              key={index}
              title={card.title}
              description={card.description}
              features={card.features}
              icon={card.icon}
              priceInfo={card.priceInfo}
              serviceType={card.serviceType}
            />
          ))}
        </div>
        
        <BusinessInfoBox />
      </div>
    </section>
  );
};

export default BusinessPricingSection;
